import React from 'react';
import '../css/title.css';

const Title = ({ text, subtext, divider, name, bigger, className }) => {
  const extraClassName = bigger ? 'bigger-title' : '';
  if (divider) return dividerTitle(text, name, [className, extraClassName].join(' '));
  return regularTitle(text, subtext, name, [className, extraClassName].join(' '));
};

const dividerTitle = (title, name, extraClassName) => (
  <h3 className={`divider-title ${extraClassName}`}><a id={name}>{title}</a></h3>
);

const regularTitle = (text, subtext, name, extraClassName) => {
  if (!subtext) return <h3 className={`title ${extraClassName}`} id={name}>{text}</h3>;
  return (
    <h3 className={`title ${extraClassName}`}>
      {text}
      <a className="small-print" id={name}>{subtext}</a>
    </h3>
  );
};

export default Title;



// WEBPACK FOOTER //
// ./src/desktop/components/title.js